import gql from 'graphql-tag';

export const allowJobRoleDelete = gql`
  query allowJobRoleDelete($id: String!) {
    allowJobRoleDelete(id: $id) {
      value
    }
  }
`;
